import {useState, useEffect} from 'react';


// Create a more detailed version of workouts for the workout library
const workoutLibrary = {
  squat: { 
    name: 'Squat', 
    category: 'Lower Body',
    primaryMuscles: ['Quadriceps', 'Glutes', 'Hamstrings'],
    equipment: 'Barbell',
    difficulty: 'Intermediate'
  },
  benchPress: { 
    name: 'Bench Press', 
    category: 'Upper Body',
    primaryMuscles: ['Chest', 'Triceps', 'Shoulders'],
    equipment: 'Barbell',
    difficulty: 'Intermediate'
  },
  deadlift: { 
    name: 'Deadlift', 
    category: 'Full Body',
    primaryMuscles: ['Hamstrings', 'Lower Back', 'Glutes'],
    equipment: 'Barbell',
    difficulty: 'Advanced'
  },
  overheadPress: { 
    name: 'Overhead Press', 
    category: 'Upper Body',
    primaryMuscles: ['Shoulders', 'Triceps'],
    equipment: 'Barbell',
    difficulty: 'Intermediate'
  },
  pullUp: { 
    name: 'Pull-Up', 
    category: 'Upper Body',
    primaryMuscles: ['Back', 'Biceps'],
    equipment: 'Pull-up Bar',
    difficulty: 'Intermediate'
  },
  lunges: { 
    name: 'Lunges', 
    category: 'Lower Body',
    primaryMuscles: ['Quadriceps', 'Glutes', 'Hamstrings'],
    equipment: 'Bodyweight/Dumbbells',
    difficulty: 'Beginner'
  },
  bicepCurl: { 
    name: 'Bicep Curl', 
    category: 'Arms',
    primaryMuscles: ['Biceps'],
    equipment: 'Dumbbells/Barbell',
    difficulty: 'Beginner'
  },
  tricepExtension: { 
    name: 'Tricep Extension', 
    category: 'Arms',
    primaryMuscles: ['Triceps'],
    equipment: 'Dumbbells/Cable',
    difficulty: 'Beginner'
  },
  legPress: { 
    name: 'Leg Press', 
    category: 'Lower Body',
    primaryMuscles: ['Quadriceps', 'Glutes', 'Hamstrings'],
    equipment: 'Machine',
    difficulty: 'Beginner'
  },
  latPulldown: { 
    name: 'Lat Pulldown', 
    category: 'Upper Body',
    primaryMuscles: ['Back', 'Biceps'],
    equipment: 'Cable Machine',
    difficulty: 'Beginner'
  }
};


// Create a WorkoutLibrary component
const WorkoutLibrary = () => {
  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.matchMedia('(max-width: 700px)').matches);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const filteredWorkouts = Object.entries(workoutLibrary).filter(([key, workout]) => {
    const matchesFilter = filter === 'all' || workout.category.toLowerCase().includes(filter.toLowerCase());
    const matchesSearch = workout.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
                          workout.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          workout.primaryMuscles.some(muscle => muscle.toLowerCase().includes(searchTerm.toLowerCase()));
    return matchesFilter && matchesSearch;
  });

  return (
    <div className="workout-library-page">
      <h1>Workout Library</h1>
      
      <div className="library-header">
        <div className="search-filter">
          <input 
            type="text" 
            placeholder="Search exercises..." 
            className="workout-search" 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <select 
            className="workout-filter"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <option value="all">All Categories</option>
            <option value="upper">Upper Body</option>
            <option value="lower">Lower Body</option>
            <option value="full">Full Body</option>
            <option value="arms">Arms</option>
          </select>
        </div>
        <button className="add-workout-btn">+ Add New Exercise</button>
      </div>
      
      {isMobile ? (
        <div className="workout-list-mobile">
          {filteredWorkouts.map(([key, workout]) => (
            <div
              key={1}
              className="workout-list-item"
              onClick={() => window.location.href = `/workouts/1`}
              style={{
                border: '1px solid #ddd',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '12px',
                cursor: 'pointer',
                background: '#fff'
              }}
            >
              <div style={{fontWeight: 'bold', fontSize: '1.1em'}}>{workout.name}</div>
              <div style={{color: '#666', marginBottom: '6px'}}>{workout.category}</div>
              <div>
                <span style={{fontWeight: 500}}>Muscles:</span> {workout.primaryMuscles.join(', ')}
              </div>
              <div>
                <span style={{fontWeight: 500}}>Equipment:</span> {workout.equipment}
              </div>
              <div>
                <span className={`difficulty-badge ${workout.difficulty.toLowerCase()}`}>
                  {workout.difficulty}
                </span>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="workout-table-container fogged-card">
          <table className="workout-table">
            <thead>
              <tr>
                <th>Exercise</th>
                <th>Category</th>
                <th>Primary Muscles</th>
                <th>Equipment</th>
                <th>Difficulty</th>
                {/* <th>Actions</th> */}
              </tr>
            </thead>
            <tbody>
              {filteredWorkouts.map(([key, workout]) => (
                <tr key={key} 
                style={{ cursor: 'pointer' }}
                onClick={() => window.location.href = `/workouts/${key}`}
                className="workout-row">
                  <td className="workout-name">{workout.name}</td>
                  <td>{workout.category}</td>
                  <td>{workout.primaryMuscles.join(', ')}</td>
                  <td>{workout.equipment}</td>
                  <td>
                    <span className={`difficulty-badge ${workout.difficulty.toLowerCase()}`}>
                      {workout.difficulty}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default WorkoutLibrary;